import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { EmptyState, PageHeader } from "@/components/shared/Common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const Row = ({ c, canEdit, onChanged }) => {
  const [name, setName] = useState(c.name);
  const save = async () => {
    if (name === c.name) return;
    try { await api.patch(`/gerencia/cost-centers/${c.id}`, { code: c.code, name, parent_id: c.parent_id }); toast.success("Actualizado"); onChanged(); }
    catch (e) { toast.error(errMsg(e)); setName(c.name); }
  };
  const toggle = async () => { try { await api.post(`/gerencia/cost-centers/${c.id}/toggle`); onChanged(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className={`flex items-center gap-3 px-5 py-2.5 border-b border-[#f0f2ee] ${c.status === "activo" ? "" : "opacity-50"}`} data-testid={`cc-row-${c.code}`}>
      <span className="font-mono text-xs w-28">{c.code}</span>
      <Input data-testid={`cc-name-${c.code}`} disabled={!canEdit} value={name} onChange={(e) => setName(e.target.value)} onBlur={save} className="h-9 flex-1" />
      <Switch data-testid={`cc-toggle-${c.code}`} disabled={!canEdit} checked={c.status === "activo"} onCheckedChange={toggle} />
    </div>
  );
};

export default function CostCenters() {
  const { can } = useAuth();
  const canEdit = can("gerencia.centros_costo.gestionar");
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ code: "", name: "" });
  const load = () => api.get("/gerencia/cost-centers").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/gerencia/cost-centers", f); setF({ code: "", name: "" }); toast.success("Centro de costo creado"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div data-testid="cost-centers-page">
      <PageHeader eyebrow="Gerencia" title="Centros de costo" subtitle="Toda OT se asocia a un centro de costo. No se eliminan: se desactivan." />
      <div className="syc-card overflow-hidden max-w-3xl">
        {canEdit && (
          <form onSubmit={add} className="flex flex-col sm:flex-row gap-2 p-4 border-b border-[#e4e8e1] bg-[#fafbf9]">
            <Input data-testid="cc-code-input" placeholder="Código" className="sm:w-40" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase() })} required />
            <Input data-testid="cc-name-input" placeholder="Nombre" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required />
            <Button data-testid="cc-add-btn" className="rounded-full"><Plus size={15} className="mr-1" />Agregar</Button>
          </form>
        )}
        {items.length === 0 ? <EmptyState title="Sin centros de costo" /> : items.map((c) => <Row key={c.id} c={c} canEdit={canEdit} onChanged={load} />)}
      </div>
    </div>
  );
}
